// extracted by mini-css-extract-plugin
module.exports = {"button":"Buttons_button__ZhekV"};